import { useState } from 'react';
import { useInterval } from 'react-use';

import { IsLiveChatScheduledOptions, isLiveChatScheduled } from '@/containers/liveChat/util/isLiveChatScheduled';

interface UseChatScheduleOptions {
  hourOpen: number;
  hourClosed: number;
  daysClosed?: Array<'Mon' | 'Tue' | 'Wed' | 'Thu' | 'Fri' | 'Sat' | 'Sun'>;
  checkIntervalMs?: number;
}

/**
 * Custom hook to manage chat availability based on business hours
 * Automatically polls to check if chat should be available
 */
export const useChatSchedule = ({
  hourOpen,
  hourClosed,
  daysClosed = ['Sat', 'Sun'],
  checkIntervalMs = 1000 * 60 // 1 minute
}: UseChatScheduleOptions) => {
  const scheduleOptions: IsLiveChatScheduledOptions = {
    daysClosed,
    hourOpen,
    hourClosed
  };

  const [isAvailable, setIsAvailable] = useState(() => isLiveChatScheduled(new Date(), scheduleOptions));

  // Poll to check chat availability
  useInterval(() => {
    setIsAvailable(isLiveChatScheduled(new Date(), scheduleOptions));
  }, checkIntervalMs);

  return {
    isAvailable,
    scheduleOptions
  };
};
